module.exports = __webpack_public_path__ + "static/media/52777712_2452983104776866_8971523499738791936_o.b3efe304.jpg";